import collectionReducer from '../collectionReducer';

export default collectionReducer({
    apiCollectionName: 'languagePacks',
    collectionActionName: 'APM_LANGUAGE_PACKS',
    itemActionName: 'APM_LANGUAGE_PACK',
});
